import React, { useState } from 'react';
import Footer from '../Footer/Footer.js';
import { Helmet } from 'react-helmet-async';
import emailjs from 'emailjs-com';
import greendumbbells from "../../assets/greendumbbells.png";
import purpledumbbells from "../../assets/purpledumbbells.png";

const Contact = (props) => {

    const [submitted, setSubmitted] = useState(false);

    const [errorMessage, setErrorMessage] = useState(false)

    const sendIt = (e) => {
        e.preventDefault()
        emailjs.sendForm("contact_form", "cftemplate", e.target, "user_790TVmLWDSNhPBz2jaEl7")
        .then((result) => {
            // window.location.reload()  //This is if you still want the page to reload (since e.preventDefault() cancelled that behavior) 
            // console.log(result)
            if (result.text === 'OK'){
                setSubmitted(true)
                setErrorMessage(false)
            }
        }, (error) => {
            console.log(error.text);
            setErrorMessage(true)
        });

    }
  
    return (
            <div className="container-page" id="contact">
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>It's A Good Life Fitness | Contact</title>
                    <script src="https://www.google.com/recaptcha/api.js" async defer></script>
                </Helmet>
                <div className="contact">
                    <h1>Contact Us</h1>
                    <h3>We’d be happy to answer any questions.<br/>Just fill out the form below!</h3>
                    <div className="background">
                        <img src={purpledumbbells} id="purpledumbbells" width="516" height="816" alt="Purple dumb bells" />
                        <img src={greendumbbells} id="greendumbbells" width="361" height="511" alt="Green dumb bells" />
                    </div>
                    <form className="contact-form" onSubmit={(e) => sendIt(e)}>
                        <div className="contact-form-half">
                            <label className="contact-form-label" htmlFor="user_name">Full Name</label>
                            <input className="contact-form-input" type="text" id="full_name" name="user_name" defaultValue="" placeholder="full name" aria-label="full name" required/>
                            <label className="contact-form-label" htmlFor="user_email">Email</label>
                            <input className="contact-form-input" type="email" id="email" name="user_email" defaultValue="" placeholder="email address" aria-label="email address" required/>
                        </div>
                        <label className="contact-form-label" htmlFor="message">Questions / Comments</label>
                        <textarea className="contact-form-input" id="contact_question" name="message" rows="5" cols="50" placeholder="questions / comments" aria-label="questions / comments" required/>
                            <div className="g-recaptcha" data-sitekey="6LcEvD0aAAAAAEchACESXdBy8PgtTzj2hylr3Jzt" data-callback="onSubmit" data-size="invisible"></div>
                        {submitted ?
                            (<div>Thank you for your message, we will get back to you as soon as possible.</div>
                        ):(
                            <input className="button" type="submit" value="Submit"/>
                       
                        )}
                        {errorMessage && (<div className="error">Error sending message, please try again soon or contact us directly at info@itsagoodlifefitness.com</div>)}
                    </form>
                </div>
                <Footer {...props}/>
            </div>
    )
}

export default Contact;